import {createAction} from 'redux-actions';
import {LEAVE_WINDOW_REMARKET} from '../action-types';

export const leaveWindowAction = createAction(LEAVE_WINDOW_REMARKET);
